import z from "zod";

export const TicketDocumentSchema = z.object({
  id: z.string(),
  contentType: z.string(),
  fileName: z.string(),
  data: z.base64(),
});
export type TicketDocument = z.infer<typeof TicketDocumentSchema>;
